import Link from "@whoppah/next/link";

import { HelpCategoryView } from "@/common/utils/help/help-category.utils";
import { getHelpCategoryPath } from "@/common/utils/help/help-url.utils";
import { Body } from "@/ui/typography/Body";

type HelpSiblingChipsProps = {
  categories: HelpCategoryView[];
};

export const HelpSiblingChips = ({ categories }: HelpSiblingChipsProps) => {
  if (!categories.length) {
    return null;
  }

  return (
    <ul className="no-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4 lg:hidden">
      {categories.map(category => (
        <li key={category.id} className="shrink-0">
          <Link
            href={getHelpCategoryPath(category.slug)}
            className="inline-flex rounded-full bg-grey-50 px-4 py-2 hover:bg-grey-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-curious-200"
          >
            <Body as="span">{category.title}</Body>
          </Link>
        </li>
      ))}
    </ul>
  );
};
